// src/features/projects/views/ProjectsHub.jsx

import AdminWorkspaceViewHeader from "../../../admin/components/dashboard/AdminWorkspaceViewHeader";
import ProjectParticipationSection from "../components/ProjectParticipationSection";

export default function ProjectsHub() {

  return (
    <div className="app-module">
      <AdminWorkspaceViewHeader title="Projects" titleId="projects-title" />
      <ProjectParticipationSection />
    </div>
  );
}
